var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 1.5,
    width: 10.9,
    height: 13.7,
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 4.9h5.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 8.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.355,
    cy: 8.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8,
    cy: 8.9,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 11.8,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.355,
    cy: 11.8,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8,
    cy: 11.8,
    r: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.a2891caeb11e96d93d4728faec38c056.svg";
export { ForwardRef as ReactComponent };